import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=07fdc61e&scoped=true&"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=07fdc61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fdc61e",
  null
  
)

export default component.exports